import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SepidzGridModule } from "projects/sepidz-web-framework-data-grid/src/lib/grid.module";
import { SharedModule } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";
import { RowAccessComponent } from "src/app/gnr/row-access/row-access.component";
import { GoodsFormComponent } from "./goods-form/goods-form.component";
import { GoodsFormulaFormComponent } from "./goods-formula/goods-formula-form/goods-formula-form.component";
import { GoodsFormulaViewFormComponent } from "./goods-formula/goods-formula-view-form/goods-formula-view-form.component";
import { GoodsFormulaComponent } from "./goods-formula/goods-formula.component";
import { GoodsSimilarFormComponent } from "./goods-formula/goods-similar/goods-similar-form.component";
import { GoodsImportExcelFormComponent } from "./goods-import-excel/goods-import-excel-form.component";
import { GoodsImportExportFormComponent } from "./goods-import-export/goods-import-export-form.component";
import { GoodsListComponent } from "./goods-list/goods-list.component";

const components = [
  GoodsListComponent,
  GoodsFormComponent,
  GoodsFormulaComponent,
  GoodsFormulaFormComponent,
  RowAccessComponent,
  GoodsImportExcelFormComponent,
  GoodsImportExportFormComponent,
  GoodsSimilarFormComponent,
  GoodsFormulaViewFormComponent,
];
@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, FormsModule, SharedModule.forRoot(), SepidzGridModule],
})
export class GoodsModule {}
